import React from 'react';
import './styles.css';
import {
  PageLayout,
  SendMessageText,
  NotificationHelper,
  SendMessageForm,
} from '@BUP/components';
import { ECE, ADMIN } from '@BUP/constants';
import { Collapse, Row, Col } from 'antd';
import { useAuth } from '@BUP/hooks';
import { useTranslation } from 'react-i18next';

// const { useBreakpoint } = Grid;

const BupSendPage = () => {
  // const screens = useBreakpoint();
  // const isSmall = !!(
  //   screens.xs ||
  //   (screens.sm && !screens.lg) ||
  //   (screens.md && !screens.lg)
  // );
  const { user } = useAuth();
  const [t] = useTranslation();
  const role = user?.roles?.type || null;

  return (
    <PageLayout pageName={t('pages.modeBup.pageName')}>
      <div className="send-message-page-container">
        <SendMessageText role={role} />
        {role === ECE || role === ADMIN ? null : (
          <Row style={{ width: '100%' }}>
            <Col
              span={24}
              style={{ display: 'flex', justifyContent: 'center' }}
            >
              <SendMessageForm />
            </Col>
            <Col span={24}>
              <div className="collapse-wrapper">
                <Collapse
                  expandIconPosition="left"
                  className="custom-site-collapse"
                >
                  <Collapse.Panel
                    key="1"
                    header={t('pages.modeBup.send.collapseTitle')}
                    className="custom-collapse-panel"
                  >
                    <p>{t('pages.modeBup.send.collapseText')}</p>
                  </Collapse.Panel>
                </Collapse>
              </div>
            </Col>
          </Row>
        )}
      </div>
      <NotificationHelper />
    </PageLayout>
  );
};

export default BupSendPage;
